import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateJobSeekerAvailability } from "../../redux/users/userSlice";
import { toast } from "react-toastify";

function JobSeekerAvailabilityUpdate() {
  const dispatch = useDispatch();
  const { currentUser, loading } = useSelector((state) => state.user);
  const [availability, setAvailability] = useState({});
  const userIdToken = localStorage.getItem("userId");

  useEffect(() => {
    if (currentUser?.interestedJob) {
      const initialAvailability = currentUser.interestedJob
        .slice(0, 3)
        .reduce((acc, job) => ({ ...acc, [job]: "available" }), {});
      setAvailability(initialAvailability);
    }
  }, [currentUser]);

  const handleUpdateAvailability = () => {
    if (!userIdToken) return toast.error("User not authenticated");
    const today = new Date().toISOString().split("T")[0];
    const payload = {
      userId: userIdToken, // Use userId from localStorage
      availability: { ...availability, lastUpdated: today },
    };
    console.log("Sending payload:", payload); // Debug payload
    dispatch(updateJobSeekerAvailability(payload)).then(() => {
      toast.success("Availability updated successfully");
    }).catch((error) => {
      toast.error(`Update failed: ${error.message}`);
    });
  };

  return (
    <div className="p-4 max-w-md mx-auto">
      <h2 className="text-xl font-bold mb-4">Update Job Availability</h2>
      {loading ? (
        <p>Loading...</p>
      ) : currentUser?.interestedJob?.length > 0 ? (
        currentUser.interestedJob.slice(0, 3).map((job) => (
          <div key={job} className="mb-2">
            <label className="block text-sm font-medium">{job}</label>
            <select
              value={availability[job] || "available"}
              onChange={(e) =>
                setAvailability({ ...availability, [job]: e.target.value })
              }
              className="w-full p-2 border rounded"
            >
              <option value="available">Available</option>
              <option value="unavailable">Unavailable</option>
            </select>
          </div>
        ))
      ) : (
        <p>No interested jobs to update.</p>
      )}
      <button
        onClick={handleUpdateAvailability}
        disabled={loading}
        className="mt-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:bg-gray-400"
      >
        Update Availability
      </button>
    </div>
  );
}

export default JobSeekerAvailabilityUpdate;